import { render, staticRenderFns } from "./GlobalSearchProductResults.vue?vue&type=template&id=3a49bc74&scoped=true"
import script from "./GlobalSearchProductResults.vue?vue&type=script&lang=js"
export * from "./GlobalSearchProductResults.vue?vue&type=script&lang=js"
import style0 from "./GlobalSearchProductResults.vue?vue&type=style&index=0&id=3a49bc74&prod&scoped=true&lang=css"
import style1 from "./GlobalSearchProductResults.vue?vue&type=style&index=1&id=3a49bc74&prod&lang=css"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "3a49bc74",
  null
  
)

export default component.exports